import React, { Component } from 'react';
import { Card, CardBody, CardLink, Button, Modal, ModalHeader, ModalBody, Col, Row, Collapse } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import ModEtapa from '../../Paginas/Admin/modEtapa'
import modificarImg from '../../Img/modificar.png'
import eliminarImg from '../../Img/eliminar.png'
import addImg from '../../Img/Plus.png'
import SideBar from '../../Img/SideBar.png'

export default class usuariosCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            poggers: false,
            isDelModalOpen: null,
            isModModalOpen: null
        }

        this.toggleDel = this.toggleDel.bind(this)
        this.toggleMod = this.toggleMod.bind(this)
    }

    toggleDel(obj) {
        this.setState({
            isDelModalOpen: obj ? obj : null
        })
    }

    toggleMod(obj) {
        this.setState({
            isModModalOpen: obj ? obj : null
        })
    }

    eliminar = (id) => {
        Fetch('/deletePeriodo', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then(response => {
                this.props.actualizarEtapa();
                this.toggleDel();
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 602:
                        console.log('Esta convocatoria no existe')
                        break;

                    default:
                        break;
                }
            })
    }

    render() {
        if(!this.props.encabezado){
        var todayDate = new Date();
        var initialDate = new Date(this.props.inicio);
        var endingDate = new Date(this.props.termino);
        }
        return (
            <div>
                <Card
                className={this.props.encabezado ? "bg-primary text-white mb-1 col-12 py-2 border-0" : "list-group-item-lighter mb-1 col-12 py-2"}>               
                    <Row className="">
                        <Col 
                        xs="3"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Etapa/Estado" : (todayDate.getTime() <= endingDate.getTime() && todayDate.getTime() >= initialDate.getTime()) ? <div className="text-success d-inline"> {this.props.nombre} </div> : <div className="text-danger d-inline"> {this.props.nombre} </div>}</Col>  
                        <Col
                        xs="3"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Incio" : <div> Activa del: <a className="text-info d-inline">{this.props.inicio ? ' '+new Date(this.props.inicio).toISOString().substr(0,10): "Sin definir"}</a></div>}</Col>
                        <Col
                        xs="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Fin" : <div>  al: <a className="text-info d-inline">{this.props.termino ? ' '+new Date(this.props.termino).toISOString().substr(0,10): "Sin definir"}</a></div>}</Col>
                        <Col 
                        xs="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Editar" : <img style={{width:'25px', height:'25px'}} className="clicable" alt="modificar imagen" src={modificarImg} onClick={() => { this.toggleMod(this.props) }} />}</Col>
                        <Col 
                        xs="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Eliminar" : <img style={{width:'25px', height:'25px'}} className="clicable" alt="eliminar imagen" src={eliminarImg} onClick={() => { this.toggleDel(this.props) }} />}</Col>
                    </Row>
                </Card>


                <Modal isOpen={this.state.isDelModalOpen !== null} toggle={() => this.toggleDel()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleDel()}>Eliminar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    <Col>
                                    ¿Seguro que desea que 
                                    <e className="font-weight-bold">
                                        {' '+this.props.nombre+' '}
                                    </e> de la Convocatoria {this.props.convocatoria} sea eliminada?
                                    </Col>
                                    <CardBody>
                                        <CardLink><Button className="btn-danger" onClick={() => this.eliminar(this.state.isDelModalOpen.id)}>Aceptar</Button></CardLink>
                                        <CardLink><Button className="btn-light" onClick={() => this.toggleDel()}>Cancelar</Button></CardLink>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isModModalOpen !== null} toggle={() => this.toggleMod()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleMod()}>Re-definir {this.props.nombre} de Convocatoria {this.props.convocatoria}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    <div>
                                        <ModEtapa id={this.props.id} documentos={this.props.documentos} convocatoria={this.props.convocatoria} nombre={this.props.nombre} inicio={this.props.inicio} termino={this.props.termino} descripcion={this.props.descripcion} cerrar={() => this.toggleMod()} actualizarEtapa={this.props.actualizarEtapa}/>
                                    </div>
                                </Card>
                            </Col>

                        </Row>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}